import React from 'react'
import { observer } from 'mobx-react-lite'
import { Icon, Scrollbar, layoutStore, Typography } from 'shared/ui'
import { TableCell } from 'shared/ui/Table'
import { useImportContactsContext } from 'pages/contacts/ui/ImportContacts/context/ImportContactsContext'
import { ImportContactDropdown } from './ImportContactDropdown/ImportContactDropdown'
import styles from './styles.module.scss'

export const MapFieldsTable = observer(() => {
  const importContactsStore = useImportContactsContext()
  const { previewContacts, headersFromFile, doNotMapNameList, mappedFields } = importContactsStore

  const renderPreviewCell = (header: string | number) => {
    const { isViewXs } = layoutStore

    return (
      <TableCell className={styles.previewCell} width={isViewXs ? 160 : 220}>
        {() =>
          previewContacts.map((contact) => {
            if (!contact[header]) return null

            return (
              <Typography
                key={contact[header]}
                className={styles.previewCellValue}
                ellipsis
                tag='div'
                variant={'body-md-regular'}
                tooltipProps={{
                  label: contact[header],
                  placement: 'top',
                  fullWidth: true,
                  maxWidth: '450px',
                }}
                ariaLabel='previewValue'
              >
                {contact[header]}
              </Typography>
            )
          })
        }
      </TableCell>
    )
  }

  const renderMappedCell = (header: string) => {
    const isDoNotMap = doNotMapNameList.includes(header)
    const showIcon = mappedFields[header] || isDoNotMap

    return (
      <TableCell
        style={{
          display: 'flex',
          justifyContent: 'start',
          alignItems: 'center',
          color: isDoNotMap ? 'var(--gray-40)' : 'var(--green-60)',
        }}
        width='100px'
        minWidth='100px'
      >
        {() => showIcon && <Icon icon={isDoNotMap ? 'minusCircle' : 'check2'} />}
      </TableCell>
    )
  }

  const renderFieldCell = (header: string) => (
    <TableCell
      style={{
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
      }}
      width={isViewXs ? '240px' : '272px'}
    >
      {() => <ImportContactDropdown header={header} />}
    </TableCell>
  )

  const { isViewXs } = layoutStore

  const columns = [
    {
      field: 'columnHeader',
      name: 'Column header',
      width: isViewXs ? 160 : 160,
      renderRowCell: (header: string | number) => (
        <TableCell
          style={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: '600',
            lineHeight: '16px',
          }}
          className={styles.columnHeaderCell}
          width='160px'
        >
          {() => header}
        </TableCell>
      ),
    },
    {
      field: 'preview',
      name: 'Preview',
      width: isViewXs ? 160 : 220,
      renderRowCell: renderPreviewCell,
    },
    {
      field: 'mapped',
      name: 'Mapped',
      width: 100,
      renderRowCell: renderMappedCell,
    },
    {
      field: 'field',
      name: 'Field',
      width: 272,
      renderRowCell: renderFieldCell,
    },
  ]

  return (
    <div className={styles.tableContainer}>
      <div className={styles.header}>
        {columns.map((column) => (
          <TableCell key={column.name} minWidth={`${column.width}px`}>
            {() => column.name}
          </TableCell>
        ))}
      </div>

      <div className={styles.bodyContainer}>
        <Scrollbar>
          {headersFromFile.map((header) => (
            <div key={header} className={styles.row}>
              {columns.map((column) => (
                <React.Fragment key={column.field}>{column.renderRowCell(header)}</React.Fragment>
              ))}
            </div>
          ))}
        </Scrollbar>
      </div>
    </div>
  )
})
